import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
// import ReportFilter from './ReportFilter';
// import ReportPreviewData from './ReportPreviewData';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { HorizonInterval } from 'src/models/Horizon';
import useFetch from 'use-http';
import PropertyUtil from 'src/util/PropertyUtil';
import ReportHorizonSequencing from 'src/models/ReportHorizonSequencing';
import ReportFilter from './ReportFilter';
import * as _ from 'lodash';
import ReportName from 'src/models/ReportName';
import SearchPanel from 'src/components/common/SearchPanel';
import SearchListData from 'src/models/SearchListData';
import Tag from 'src/models/Tag';
import ReportPreviewData from './ReportPreviewData';
import ReportHorizonDto from 'src/models/reports/ReportHorizonDto';

// interface IReportDetailProps {
//     id: number;
//     reportNumber: number;
//     groupNumber: number;
//     name: string;
//     filters: [{id: number, }]
// }

const ReportDetail = () => {
    const ssrsPrefix = process.env.REACT_APP_SSRS_PREFIX;

    const dispatch = useDispatch();
    const { get, response } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);
    const [reportData, setReportData] = useState<ReportName>(null);
    const [horizonIntervals, setHorizonIntervals] = useState<HorizonInterval[]>([]);
    const [selectedHorizons, setSelectedHorizons] = useState<HorizonInterval[]>([]);
    const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
    const [horizonSequenceReports, setHorizonSequenceReports] = useState<ReportHorizonSequencing[]>([]);
    const [selectedSequence, setSelectedSequence] = useState<number>(undefined);
    const [ssrsUrl, setSsrsUrl] = useState<string>(undefined);

    useEffect(() => {
        getUniqueHorizonIntervals();
        getHorizonSequencingReports();
        getReportData();
    }, []);

    useEffect(() => {
        if (horizonSequenceReports.length > 0 && selectedHorizons.length > 0) {
            updateHorizonSequence(selectedHorizons);
        }
    }, [horizonSequenceReports]);

    const getReportData = async () => {
        const reportName: ReportName = await get(`v1.0/reports/report-group/${appContext.reportId}`);

        if (response.ok) {
            setReportData(reportName);
        }
    };

    const navReportPage = () => {
        dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/reports`));
    };

    const getUniqueHorizonIntervals = async () => {
        const data: HorizonInterval[] = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/horizon-intervals`);

        if (response.ok) {
            setHorizonIntervals(data);
        }
    };

    const getHorizonSequencingReports = async () => {
        const sequenceData: ReportHorizonSequencing[] = await get(
            `v1.0/reports/sequence-horizons/clientId/${appContext.clientNumber}/projectId/${appContext.projectNumber}`
        );

        if (response.ok) {
            setHorizonSequenceReports(sequenceData);
        }
    };

    const updateHorizonIntervals = (horizons: ReportHorizonDto[]) => {
        setSsrsUrl(undefined);

        let cloneHorizonIntervals: Array<HorizonInterval> = [];
        if (PropertyUtil.SafeGet(() => horizons)) {
            cloneHorizonIntervals = horizons.map((hor: ReportHorizonDto) => {
                return HorizonInterval.fromSummary(hor);
            });
        }

        for (let i = 0; i < cloneHorizonIntervals.length; i++) {
            const hi = cloneHorizonIntervals[i];

            hi.from.calcType();
            hi.to.calcType();
        }

        updateHorizonSequence(cloneHorizonIntervals);
        
        setSelectedHorizons(cloneHorizonIntervals);
    };
    
    const updateHorizonSequence = (intervals: HorizonInterval[]) => {
        let sequenceSelection: number;

        horizonSequenceReports.some((hsr, index) => {
            let sequenceIntervalIds = hsr.horizonSequences.map((hs) => {
                return hs.horizonIntervalId;
            });

            let cloneIntervalIds = intervals.map((hi) => {
                return hi.id;
            });

            if (_.isEqual(sequenceIntervalIds.sort((r1, r2) => r1 - r2), cloneIntervalIds.sort((ci1, ci2) => ci1 - ci2))) {
                sequenceSelection = index;
            }

            return sequenceSelection !== undefined;
        });

        setSelectedSequence(sequenceSelection);
    };

    const onLoadReport = (reportId: number) => {
        // NOTE: This will still only work in our local server's LMSProd as opposed to the normal LMS schema.
        let url = `${ssrsPrefix}${reportData.name}&ReportID=${reportId}&GlobalID=1&rs\:ClearSession=true&rs\:Embed=true&rc\:LinkTarget=_blank`;
        setSsrsUrl(url);
    };

    const updateFilterData = (filterData: SearchListData[]) => {
        if (filterData?.length > 0) {
            let selected = filterData.filter(fd => fd.state === true).map(ft => ft.tag);
            setSelectedTags(selected);
        }
    };

    // let reportServer: string =
    //     `http://3.130.84.70:80/ReportServer/Pages/ReportViewer.aspx?/` +
    //     `LMSRPT/Menu&rs:embed=true&ClientNumber=${appContext.clientNumber}&ProjectNumber=${appContext.projectNumber}`;

    return (
        <div style={{ margin: '1rem' }}>
            <div className="report-page-title">Report Detail</div>
            {(reportData && (
                <>
                    <div style={{ display: 'flex' }}>
                        <div className="report-tags">
                            <SearchPanel
                                updateFilterString={updateFilterData}
                            />
                        </div>
                        <div className="report-detail">
                            <div className="report-detail-info">
                                <div className="report-detail-name">
                                    <span style={{ marginRight: '1rem' }}>{reportData.title}</span>
                                    <span>{reportData.reportNumberDisplay}</span>
                                </div>
                            </div>

                            <div className="report-section">
                                <div className="filter">
                                    <ReportFilter
                                        reportNumber={reportData.reportNumber}
                                        reportName={reportData}
                                        horizonIntervals={horizonIntervals}
                                        selectedSequence={(horizonSequenceReports.length > selectedSequence) ? horizonSequenceReports[selectedSequence] : undefined}
                                        // selectedHorizons={selectedHorizons}
                                        selectedTags={selectedTags}
                                        updateHorizonIntervals={updateHorizonIntervals}
                                        onGetReportId={onLoadReport}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="data-preview">
                        {(reportData.sequencingRequired && !ssrsUrl) && (
                            <>
                                {selectedSequence === undefined && (
                                    <div>
                                        <span style={{ color: 'red' }}>Please review and submit Horizon Sequence</span>
                                    </div>
                                )}
                                {selectedSequence !== undefined && (
                                    <div>
                                        <span>Valid Horizon Sequence found...</span>
                                    </div>
                                )}

                                <ReportPreviewData
                                    selectedHorizons={selectedHorizons}
                                    selectedSequence={(horizonSequenceReports.length > selectedSequence) ? horizonSequenceReports[selectedSequence] : undefined}
                                    clientId={appContext.clientNumber}
                                    projectId={appContext.projectNumber}
                                    updateHorizonSequences={getHorizonSequencingReports}
                                />

                                {/* <div onClick={navReportPage} className="clickable">Back To All Reports</div> */}
                                <Button text="Back To All Reports" onClick={navReportPage} size="medium" />
                            </>
                        )}

                        {!!ssrsUrl && (
                            <div>
                                <iframe
                                    referrerPolicy="same-origin"
                                    width="100%"
                                    height={500}
                                    src={ssrsUrl}
                                    sandbox="allow-scripts allow-same-origin allow-forms allow-downloads allow-popups allow-popups-to-escape-sandbox"
                                />
                            </div>
                        )}
                    </div>
                </>
            )) || <div>Loading...</div>}
        </div>
    );
};

export default ReportDetail;



// WEBPACK FOOTER //
// ./src/components/project/sections/ReportComponents/ReportDetail.tsx